/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../molecules/teaser/css/teaser';
import '../../../molecules/marketing-teaser/css/marketing-teaser';
import './teaser-row.scss';
import './modifier/image-large.scss';
import './modifier/image-large-right.scss';
import './modifier/image-large-left.scss';
import './modifier/text-image.scss';
import './modifier/image-small.scss';
